import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { FaRegHeart, FaRegThumbsUp } from 'react-icons/fa';
import { LikeBurst } from './LikeBurst';

export const LikeButton = ({ isLiked, onLike, onUnlike, likeCount }) => {
  const [showBurst, setShowBurst] = useState(false);

  const prevLikedRef = useRef(isLiked);

  useEffect(() => {
    if (!prevLikedRef.current && isLiked) {
      // Only trigger burst when going from unliked → liked
      setShowBurst(true);
      setTimeout(() => {
        setShowBurst(false);
      }, 1000);
    }

    prevLikedRef.current = isLiked;
  }, [isLiked]);

  const handleClick = () => {
    if (isLiked) {
      onUnlike?.();
    } else {
      onLike?.();
    }
  };

  return (
    <div className="relative overflow-visible text-sm">
      {showBurst && <LikeBurst />}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={handleClick}
        className={`flex items-center z-30 relative ${
          isLiked ? 'text-orange-600' : 'text-gray-500'
        }`}
      >
        <FaRegHeart size={16}/>
        &nbsp;Likes {likeCount}
      </motion.button>
    </div>
  );
};